import React from "react";
import { cn } from "@/lib/utils";
import { formatUnreadNotificationCount } from "@/activity/use-unread-notification-count";

export function NotificationCountBadge({ count, className }: { count: number; className?: string }) {
  if (count <= 0) return null;
  return (
    <span
      className={cn(
        "inline-flex min-w-5 items-center justify-center rounded-full bg-red-500 px-1.5 text-[10px] font-bold leading-5 text-white",
        className,
      )}
      aria-label={`읽지 않은 알림 ${count}개`}
    >
      {formatUnreadNotificationCount(count)}
    </span>
  );
}
